const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const scrollActiveMenu = () => {

    const sectionsContent = gsap.utils.toArray(".section-content");
    const linkActived = '#nav-header a';

    sectionsContent.forEach((section) => {

        let sectionCurrent = $(section).attr('id');

        ScrollTrigger.create({
            onEnter: () => {
                $("#nav-header a[data-scrollto='#" + sectionCurrent + "']").addClass('actived');
            },
            onLeave: () => {
                $(linkActived).removeClass('actived');
            },
            onEnterBack: () => {
                $("#nav-header a[data-scrollto='#" + sectionCurrent + "']").addClass('actived');
            },
            onLeaveBack: () => {
                $(linkActived).removeClass('actived');
            },
            //onEnter, onLeave, onEnterBack, onLeaveBack
            toggleActions: "play pause play pause",
            start: 'top 60%',
            end: 'bottom 60%',
            trigger: section,
            immediateRender: false,
            // markers: true,

        });

    })

}

const Menu = function () {

    const _body = $('body');
    var menuAll = $('#nav-header');


    const menuMobile = ((_this) => {
        //$('#bt-menu-mobile').toggleClass('motion-in');
        $("#wrap-sandwitch,#nav-icon3").toggleClass('open');
        menuAll.toggleClass('actived');
        if ($(window).width() < 768) {
            _body.toggleClass('scroll-off');
        }

    });


    return {
        init: function () {

            scrollActiveMenu();

            //new
            $('#wrap-sandwitch, #nav-header a').on('click', function () {
                $("#wrap-sandwitch").toggleClass('open');
                menuMobile($(this));
            });

            /* $(document).on('click', '#nav-header a, .ico-header-logo', function (e) {
                e.preventDefault();
                $("#nav-header a").removeClass('actived');
                $(this).addClass('actived');
            }); */



        }
    }

}();

module.exports = Menu;